import { createContext, useCallback, useState } from "react";

export const ResponseContext = createContext({});

function ResponseProvider({ children }) {
  const [responses, setResponses] = useState({});

  const setResponse = useCallback((key, value, message = "") => {
    setResponses((prev) => ({ ...prev, [key]: { status: value, message } }));
    setTimeout(() => {
      setResponses((prev) => ({ ...prev, [key]: null }));
    }, 3000);
  }, []);

  const getResponse = useCallback((key) => responses[key] ?? null, [responses]);

  return (
    <ResponseContext.Provider value={{ getResponse, setResponse }}>
      {children}
    </ResponseContext.Provider>
  );
}

export default ResponseProvider;
